import { useEffect, useState } from 'react';
import { parseIso } from '../aiinterview/recruiter/common';

export function useNow(ms = 1000) {
  const [t, setT] = useState(Date.now());
  useEffect(() => { const i = setInterval(() => setT(Date.now()), ms); return () => clearInterval(i); }, [ms]);
  return t;
}

export const fmtCountdown = (iso, now) => {
  const s = Math.max(0, Math.round((parseIso(iso).getTime() - now) / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = String(s % 60).padStart(2, '0');
  return h ? `${h}h ${m}m` : `${m}:${sec}`;
};

export const fmtClockTime = (iso, tz) => (iso ? parseIso(iso).toLocaleString(undefined, {
  timeZone: tz, weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }) : '');
